import { IStore } from 'store/types';

export const selectAchTransactions = () => (state: IStore) => state?.collections?.ach;
